// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { __decorate, __metadata, __param } from "tslib";
import { Inject, Scoped } from 'vue-di';
/* tslint:disable:no-unused-locals */
import { Serializer, } from '@trialcard/apigateway.models';
import { OAuth, OAuthTokenProvider, OAUTH_TOKEN_PROVIDER } from '@trialcard/authentication';
import { X_TC_USERID } from '@trialcard/shared';
import { AXIOS, AUDIENCE, BASE_PATH } from './symbols';
// ===============================================
// This file is autogenerated - Please do not edit
// ===============================================
let PharmacyV2Api = class PharmacyV2Api {
    constructor(axios, xTcUserId, audience, url, tokenProvider) {
        this.axios = axios;
        this.authentications = {
            'Token': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
        };
        if (this.authentications.UserId) {
            this.authentications.UserId.apiKey = xTcUserId;
        }
    }
    /**
     *
     * @summary Get a Pharmacy by Tenant and Pharmacy identifiers
     * @param pharmacyId Pharmacy identifier.
     */
    async pharmacyGetByTenantId(pharmacyId) {
        const _url_ = '/pharmacy/v2/Pharmacy/{pharmacyId}'
            .replace('{' + 'pharmacyId' + '}', encodeURIComponent(String(pharmacyId)));
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'pharmacyId' is not null or undefined
        if (pharmacyId === null || pharmacyId === undefined) {
            throw new Error('Required parameter pharmacyId was null or undefined when calling pharmacyGetByTenantId.');
        }
        let requestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PharmacyModelResponse");
        }
        return response;
    }
    /**
     *
     * @summary Search for existing Pharmacy
     * @param PharmacySearchModel PharmacySearchModel object
     */
    async pharmacySearchByTenantId(PharmacySearchModel) {
        const _url_ = '/pharmacy/v2/PharmacySearch';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'PharmacySearchModel' is not null or undefined
        if (PharmacySearchModel === null || PharmacySearchModel === undefined) {
            throw new Error('Required parameter PharmacySearchModel was null or undefined when calling pharmacySearchByTenantId.');
        }
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(PharmacySearchModel, "PharmacySearchModel"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PharmacySearchModelResponse");
        }
        return response;
    }
    /**
     *
     * @summary Upsearch Pharmacy
     * @param UpsearchModelPharmacyPharmacyUpsearchModel Upsearch Model(PharmacyUpsearchModel) object
     */
    async pharmacyUpsearchByTenantId(UpsearchModelPharmacyPharmacyUpsearchModel) {
        const _url_ = '/pharmacy/v2/PharmacyUpsearch';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'UpsearchModelPharmacyPharmacyUpsearchModel' is not null or undefined
        if (UpsearchModelPharmacyPharmacyUpsearchModel === null || UpsearchModelPharmacyPharmacyUpsearchModel === undefined) {
            throw new Error('Required parameter UpsearchModelPharmacyPharmacyUpsearchModel was null or undefined when calling pharmacyUpsearchByTenantId.');
        }
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(UpsearchModelPharmacyPharmacyUpsearchModel, "UpsearchModelPharmacyPharmacyUpsearchModel"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PharmacyLongResponse");
        }
        return response;
    }
};
PharmacyV2Api = __decorate([
    Scoped,
    __param(0, Inject(AXIOS)),
    __param(1, Inject(X_TC_USERID)),
    __param(2, Inject(AUDIENCE)),
    __param(3, Inject(BASE_PATH)),
    __param(4, Inject(OAUTH_TOKEN_PROVIDER)),
    __metadata("design:paramtypes", [Function, String, String, String, OAuthTokenProvider])
], PharmacyV2Api);
export { PharmacyV2Api };
//# sourceMappingURL=pharmacyV2Api.js.map